var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"body"},[(_vm.layout)?_c(_vm.layoutName,{tag:"component",class:{'withMinHeight': _vm.layoutName.indexOf(['businesses-layout']) !== -1}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }